import { render, staticRenderFns } from "./jyj_fenlei.vue?vue&type=template&id=96e5666a&scoped=true"
import script from "./jyj_fenlei.vue?vue&type=script&lang=js"
export * from "./jyj_fenlei.vue?vue&type=script&lang=js"
import style0 from "./jyj_fenlei.vue?vue&type=style&index=0&id=96e5666a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX-JYJ\\WEB\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e5666a",
  null
  
)

export default component.exports